import {Injectable} from "@angular/core";
import _ from "lodash";

@Injectable({
    providedIn: "root"
})
export class ChartPropertiesService {

    isPie(project: Object): boolean {
        return getType(project) === "pie";
    }

    simplifyView(options: any): void {
        _.set(options, "title.text", "");
        _.set(options, "subtitle.text", undefined);
        _.set(options, "legend.enabled", false);
        options.series = options.series || [];
        options.series.forEach((s: { name: string; }) => {
            _.set(s, "dataLabels.enabled", false);
            s.name = "";
        });

        options.chart.margin = 10;

        options.xAxis = options.xAxis || [{visible: false}];
        options.yAxis = options.yAxis || [{visible: false}];
        options.zAxis = options.zAxis || [{visible: false}];

        Array.isArray(options.xAxis)
            ? _.forEach(options.xAxis, ax => _.merge(ax, {visible: false}))
            : options.xAxis = {visible: false};

        Array.isArray(options.yAxis)
            ? _.forEach(options.yAxis, ax => _.merge(ax, {visible: false}))
            : options.yAxis = {visible: false};

        Array.isArray(options.zAxis)
            ? _.forEach(options.zAxis, ax => _.merge(ax, {visible: false}))
            : options.zAxis = {visible: false};
    }

    loadDataToChart(project: any, data: any[]): void {
        if (!project.options.series) {project.options.series = [];}

        for (let i = 0; i < data.length; i++) {
            const fromSheet = data[i];
            const fromChart = project.options.series[i];

            if (fromSheet && fromChart) {
                fromChart.name = fromSheet.name;
                fromChart.data = fromSheet.data;
            }

            if (!fromChart && fromSheet) {
                project.options.series.push(fromSheet);
            }
        }

        if (project.options.series.length > data.length) {project.options.series.splice(data.length);}
    }

    setPreviewOptions(options: any, height?: number, width?: number) {
        if (!options) {
            return;
        }
        options.tooltip = {enabled: false};
        options.plotOptions = options.plotOptions || {};
        options.plotOptions.series = options.plotOptions.series || {};
        options.plotOptions.series.enableMouseTracking = false;
        options.plotOptions.series.states = {hover: {enabled: false}};

        options.chart = options.chart || {};
        if (height && width) {
            options.chart.height = height;
            options.chart.width = width;
        }
        options.chart.animation = false;
        if (options.series && options.series.length) {
            options.series.forEach((series: { animation?: boolean }) => (series.animation = false));
        }
        options.credits = {enabled: false};
        options.loading = {
            showDuration: 0,
            hideDuration: 0
        };
    }

    removeNullValues(obj: any): void {
        if (!obj || typeof obj !== 'object') return;

        for (const key of Object.keys(obj)) {
            if (obj[key] === null) {
                delete obj[key];
            } else if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
                this.removeNullValues(obj[key]);
            } else if (Array.isArray(obj[key])) {
                obj[key].forEach((item: any) => this.removeNullValues(item));
            }
        }
    }

}

function getType(project: Object): string | undefined {
    return project && (_.get(project, "options.chart.type") ||
        _.get(project, "template.chart.type"));
}
